import { Injectable } from '@angular/core';
import { IGridColumn } from './../../components/data-grid/interfaces/IColumn.interface';

@Injectable({
    providedIn: 'root',
})
export class ColumnsNameMapper {
    constructor() {}

    public mapColumnsName(columns: IGridColumn[]): string[] {
        const columnsName: string[] = [];

        for (const column of columns) {
            columnsName.push(column.name);
        }

        return columnsName;
    }
}
